import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  content: {
    flexGrow: 1,
    width: "100%",
  },
  reportTabs: {
    background: "none",
    boxShadow: "none",
    position: "fixed",
    top: 65,
    left: "25%",
    width: "auto",
    paddingTop: 11,
    height: 55,
    transition: "left .2s linear",
    "& .MuiTabs-root": {
      height: "100%",
    },
    "@media (min-width: 2200px)": {
      left: "30%",
    },
    "@media (min-width: 3000px)": {
      left: "35%",
    },
    "@media (min-width: 4000px)": {
      left: "40%",
    },
    "@media (max-width: 1600px)": {
      left: "17%",
    },
    // "@media (max-width: 1400px)": {
    //   left: 200,
    // },
    "@media (max-width: 1024px)": {
      left: "23%",
    },
    [theme.breakpoints.down("xs")]: {
      left: 16,
      top: 55,
      width: "100%",
    },
    "& button": {
      fontSize: 14,
      opacity: 1,
      minWidth: "auto",
      padding: 0,
      marginRight: 30,
      [theme.breakpoints.down("sm")]: {
        fontSize: 14,
        marginRight: 20,
      },
      "&.Mui-selected": {
        fontWeight: 600,
        color: "#041E41",
      },
    },
    "& .PrivateTabIndicator-root": {
      height: 3,
    },
  },
  updateTabPosition: {
    left: "35%",
    "@media (min-width: 3000px)": {
      left: "40%",
    },
    "@media (min-width: 4000px)": {
      left: "45%",
    },
    "@media (max-width: 850px)": {
      left: "45%",
    },
  },
}));
